/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Agent_WorkingInputs */



/**
* | output |
* | --- |
* | "Working..." |
*
* @param {Assistant_Agent_WorkingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_agent_working = /** @type {((inputs?: Assistant_Agent_WorkingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Agent_WorkingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fonctionnement...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Arbeiten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lavorando...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Работающий...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Laboral...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在职的...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("働く...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यरत...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Trabalhando...")
	return /** @type {LocalizedString} */ ("Working...")
});